import React from 'react'
import { Dialog, DialogContent, DialogTitle, Typography, IconButton, Box } from '@mui/material'
import CloseIcon from '../../icons/closeIcon'

interface FormationTitleDialogProps {
  open: boolean
  onClose: () => void
  title: string
  moodleLink?: string
  // Pendant une personnification, ouvre Moodle au nom du membre (useOpenMoodleLink)
  onMoodleLinkClick?: (event: React.MouseEvent) => void
}

const FormationTitleDialog: React.FC<FormationTitleDialogProps> = ({
  open,
  onClose,
  title,
  moodleLink,
  onMoodleLinkClick
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '8px',
          margin: { xs: '16px', sm: '32px' },
          maxHeight: { xs: '90vh', sm: '80vh' },
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start',
        padding: { xs: '16px', sm: '24px' },
        paddingBottom: { xs: '8px', sm: '12px' }
      }}>
        <Typography variant='h6' sx={{ 
          fontSize: { xs: '14px', sm: '16px' },
          fontWeight: 'bold',
          lineHeight: 1.4,
          color: '#333',
          marginRight: '16px'
        }}>
          Titre complet de la formation
        </Typography>
        <IconButton 
          onClick={onClose}
          sx={{ 
            padding: '4px',
            marginTop: '-4px',
            marginRight: '-8px'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ 
        padding: { xs: '0 16px 24px', sm: '0 24px 32px' },
        paddingTop: '0 !important'
      }}>
        <Box sx={{
          backgroundColor: '#f8f9fa',
          borderRadius: '6px',
          padding: { xs: '12px', sm: '16px' },
          border: '1px solid #e9ecef'
        }}>
          {moodleLink ? (
            <Typography
              variant='h6'
              component='a'
              href={moodleLink}
              target='_blank'
              onClick={onMoodleLinkClick}
              sx={{
                textDecoration: 'underline',
                cursor: 'pointer',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                lineHeight: '1.4',
                display: 'block',
                '&:hover': {
                  color: '#1976d2'
                }
              }}
            >
              {title}
            </Typography>
          ) : (
            <Typography 
              variant='h6'
              sx={{
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                lineHeight: '1.4'
              }}
            >
              {title}
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default FormationTitleDialog
